import { SVGProps } from 'react'

type Props = {
  width?: number
  height?: number
} & SVGProps<SVGSVGElement>

export function BalanceIconGemsBg({
  width = 181,
  height = 123,
  ...props
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 181 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.2" filter="url(#filter0_f_62738_56720)">
        <ellipse
          cx="98.4361"
          cy="84.2238"
          rx="72.7759"
          ry="13.2238"
          fill="url(#paint0_linear_62738_56720)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter1_f_62738_56720)">
        <path
          d="M149.943 89.6279C149.943 90.9099 126.317 95.4477 95.6795 95.4477C65.0416 95.4477 40.2047 94.4084 40.2047 93.1265C3.00678 90.0851 67.7645 77.5981 98.4024 77.5981C129.04 77.5981 149.943 88.346 149.943 89.6279Z"
          fill="url(#paint1_linear_62738_56720)"
        />
      </g>
      <g opacity="0.3" filter="url(#filter2_f_62738_56720)">
        <ellipse
          cx="87.5708"
          cy="90.8905"
          rx="65.5708"
          ry="6.55701"
          fill="url(#paint2_linear_62738_56720)"
        />
      </g>
      <g opacity="0.3" filter="url(#filter3_f_62738_56720)">
        <ellipse
          cx="91.3284"
          cy="93.1785"
          rx="56.6213"
          ry="2.63452"
          fill="url(#paint3_linear_62738_56720)"
        />
      </g>
      <path
        d="M84.2584 14.7781C84.3542 14.5308 84.5443 14.3316 84.7869 14.2245L105.788 4.94731C106.03 4.84014 106.305 4.83373 106.553 4.92949L120.01 10.14C120.257 10.2357 120.456 10.4258 120.563 10.6684L129.84 31.6692C129.948 31.9117 129.954 32.187 129.858 32.4343L115.529 69.4406C115.434 69.688 115.244 69.8871 115.001 69.9943L94.0002 79.2714C93.7576 79.3786 93.4824 79.385 93.2351 79.2892L79.7782 74.0788C79.5309 73.983 79.3318 73.7929 79.2246 73.5503L69.9474 52.5496C69.8403 52.307 69.8338 52.0318 69.9296 51.7844L84.2584 14.7781Z"
        fill="#E96565"
        stroke="#60050F"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M70.8616 52.1455L85.1904 15.1392L96.1779 24.2292L85.1057 52.825L70.8616 52.1455Z"
        fill="#EE8BBB"
      />
      <path
        d="M106.192 5.86203L85.1909 15.1392L96.1785 24.2293L109.664 16.8778L119.649 11.0725L106.192 5.86203Z"
        fill="#FFC1DF"
      />
      <path
        d="M103.61 59.9893L90.125 67.3407L80.14 73.146L93.5968 78.3565L114.598 69.0793L128.926 32.073L119.649 11.0723L109.664 16.8776L114.682 31.3935L103.61 59.9893Z"
        fill="#D74E67"
      />
      <path
        d="M128.925 32.0731L114.597 69.0794L103.609 59.9893L114.681 31.3935L128.925 32.0731Z"
        fill="#AC2F6B"
      />
      <circle
        cx="122.305"
        cy="39.1811"
        r="1.8038"
        transform="rotate(21.1664 122.305 39.1811)"
        fill="#BE3778"
      />
      <circle
        cx="117.434"
        cy="45.5159"
        r="1.35285"
        transform="rotate(21.1664 117.434 45.5159)"
        fill="#BE3778"
      />
      <circle
        cx="121.191"
        cy="44.5532"
        r="0.901898"
        transform="rotate(21.1664 121.191 44.5532)"
        fill="#BE3778"
      />
      <circle
        cx="117.963"
        cy="40.4018"
        r="0.901898"
        transform="rotate(21.1664 117.963 40.4018)"
        fill="#BE3778"
      />
      <circle
        cx="125.099"
        cy="34.4604"
        r="0.901898"
        transform="rotate(21.1664 125.099 34.4604)"
        fill="#BE3778"
      />
      <circle
        cx="117.283"
        cy="54.6457"
        r="0.901898"
        transform="rotate(21.1664 117.283 54.6457)"
        fill="#BE3778"
      />
      <circle
        cx="118.912"
        cy="50.4406"
        r="0.901898"
        transform="rotate(21.1664 118.912 50.4406)"
        fill="#BE3778"
      />
      <path
        d="M96.1796 24.2291L85.1073 52.8249L90.1254 67.3408L103.595 60.0287L114.683 31.3935L109.665 16.8776L96.1796 24.2291Z"
        fill="#FF6480"
      />
      <path
        d="M85.1073 52.8249L96.1796 24.2291L109.665 16.8776L114.683 31.3935L85.1073 52.8249Z"
        fill="#FF9BAD"
      />
      <path
        d="M108.687 19.4009L97.535 25.7215L90.6962 43.3837"
        stroke="#FFD5E4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.8965 18.3135L73.5216 50.2735"
        stroke="#FFADD4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.8808 15.6007L106.381 7.86968"
        stroke="#FFE7F2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="107.476"
        cy="68.7398"
        r="1.35285"
        transform="rotate(21.1664 107.476 68.7398)"
        fill="#B43B51"
      />
      <circle
        cx="95.8092"
        cy="73.8936"
        r="1.35285"
        transform="rotate(21.1664 95.8092 73.8936)"
        fill="#B43B51"
      />
      <circle
        cx="100.475"
        cy="71.8321"
        r="1.35285"
        transform="rotate(21.1664 100.475 71.8321)"
        fill="#B43B51"
      />
      <circle
        cx="97.5047"
        cy="68.2641"
        r="0.901898"
        transform="rotate(21.1664 97.5047 68.2641)"
        fill="#B43B51"
      />
      <circle
        cx="103.392"
        cy="70.5437"
        r="0.901898"
        transform="rotate(21.1664 103.392 70.5437)"
        fill="#B43B51"
      />
      <circle
        cx="102.171"
        cy="66.2023"
        r="1.8038"
        transform="rotate(21.1664 102.171 66.2023)"
        fill="#B43B51"
      />
      <defs>
        <filter
          id="filter0_f_62738_56720"
          x="0.660156"
          y="46"
          width="195.552"
          height="76.4478"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="12.5"
            result="effect1_foregroundBlur_62738_56720"
          />
        </filter>
        <filter
          id="filter1_f_62738_56720"
          x="13.9971"
          y="62.5981"
          width="150.945"
          height="47.8496"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="7.5"
            result="effect1_foregroundBlur_62738_56720"
          />
        </filter>
        <filter
          id="filter2_f_62738_56720"
          x="17"
          y="79.3335"
          width="141.142"
          height="23.114"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.5"
            result="effect1_foregroundBlur_62738_56720"
          />
        </filter>
        <filter
          id="filter3_f_62738_56720"
          x="31.707"
          y="87.5439"
          width="119.242"
          height="11.269"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_62738_56720"
          />
        </filter>
        <linearGradient
          id="paint0_linear_62738_56720"
          x1="98.436"
          y1="67.7517"
          x2="98.4361"
          y2="97.4476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB9355" stopOpacity="0" />
          <stop offset="1" stopColor="#AC7D4B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_62738_56720"
          x1="98.0699"
          y1="73.8699"
          x2="97.8563"
          y2="95.4692"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AC7D4B" stopOpacity="0.27" />
          <stop offset="0.919275" stopColor="#81674C" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_62738_56720"
          x1="147.69"
          y1="97.4474"
          x2="22"
          y2="97.4469"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB9355" stopOpacity="0" />
          <stop offset="0.50698" stopColor="#9C4844" />
          <stop offset="1" stopColor="#856139" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_62738_56720"
          x1="143.242"
          y1="95.813"
          x2="34.707"
          y2="95.812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#95813A" stopOpacity="0" />
          <stop offset="0.50698" stopColor="#7D6922" />
          <stop offset="1" stopColor="#856139" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
